export default "__VITE_ASSET__D41MZpBh__"